import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { RouteSwitch } from 'components';

import { Exit } from 'screens/shared';
import { DpfSoot } from 'screens/Diesel';
import ServiceStats from './ServiceStats/ServiceStats';

class Service extends Component {
  showRoute = ({
    ComponentName,
    match,
    content,
    route
  }) => (
    <Route
      exact
      path={`${match.url}/${route}`}
      key={content.title}
      render={routeProps =>
        (<ComponentName
          {...routeProps}
          content={content}
        />)}
    />
  );

  renderRoutes = (ComponentName, routes) => {
    const { match, content } = this.props;

    return Object.keys(routes).map(key => (
      this.showRoute({
        ComponentName,
        match,
        content: content[key],
        route: routes[key]
      })
    ));
  }

  render() {
    const {
      routes,
      match,
      content,
      flowId
    } = this.props;
    const { url } = match;
    const mainRoutes = routes.mainRoutes || routes;

    let output = <div />;

    if (Object.keys(content).length > 0) {
      output = (
        <RouteSwitch>
          {this.renderRoutes(ServiceStats, mainRoutes)}
          {flowId === 3 &&
            this.showRoute({
              ComponentName: DpfSoot,
              match,
              content: content.dpfSoot,
              route: routes.dpfSoot
            })
          }
          <Route
            exact
            path={`${url}/exit`}
            render={() =>
              (<Exit
                text={content.exit.title}
                destinations={content.exit.routes}
              />)
            }
          />
          <Redirect from={url} to={`${url}/trans-oil`} />
        </RouteSwitch>
      );
    }

    return output;
  }
}

Service.defaultProps = {
  content: null
};

Service.propTypes = {
  routes: PropTypes.shape({}).isRequired,
  match: PropTypes.shape({
    url: PropTypes.string.isRequired
  }).isRequired,
  content: PropTypes.shape({}),
  flowId: PropTypes.number.isRequired
};

export default withRouter(connect(({ service, workflow }) => ({
  content: service,
  flowId: workflow.id
}))(Service));



// WEBPACK FOOTER //
// ./src/screens/shared/Service/Service.js